import { Component, OnInit, HostListener, Inject, AfterViewInit, ElementRef, ViewChild  } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { CommonService } from "../../services/common.service";
import { NgbDate, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HotelDialogComponent } from '../hotel-dialog/hotel-dialog.component';
import { AuthService } from '../../shared/providers/auth.service';
@Component({
  selector: 'app-inner-header',
  templateUrl: './inner-header.component.html',
  styleUrls: ['./inner-header.component.scss']
})
export class InnerHeaderComponent implements OnInit {
	@ViewChild('header', { static: false }) header: ElementRef;
  @ViewChild('popupcart', { static: false }) popupcart: ElementRef;
  @ViewChild('popupcalendar', { static: false }) popupcalendar: ElementRef;
  @ViewChild('giftcard', { static: false }) giftcard: ElementRef;
  // @ViewChild('giftcard', { static: false }) giftcard: ElementRef;
  headerHeight: number;
  private hotel_code: string;
  private hotelData: any = {};
  private hotelID : number;
  searchshow: boolean= false;
  menuToggle: boolean= false;
  logoImage : string = '';
  logoImageMobile : string = '';
  public showCartDropDown: boolean= false;
  public showGFDropDown: boolean= false;
  public showLoader: boolean= false;
  public isLoggedIn: boolean= false;
  showCalendarDropDown: boolean= false;
  public cartData:any = [];
  public cartTotal:any = [];
  public totalCartItems;
  private popupcartHeight;
  private popupcalendarHeight;
  private cartSubscription;
  private giftcardHeight;
  private hotelDataSubscription;
  hoveredDate: NgbDate;
  fromDate: NgbDate;
  toDate: NgbDate;
  logoImageBoolean: boolean = false;
  private cartpopup; 
  private logInsubscription:any;
  private loggedInStatus:any;
  private showCommonLoader:boolean = false;
  private commonLoaderSub:any;
  private hotel_title:any;
  ngAfterViewInit() {
      this.headerHeight = this.header.nativeElement.offsetHeight;
      document.getElementsByTagName("body")[0].style.paddingTop = this.headerHeight + 'px';
      this.loadCartData();
      this.headerHeight = this.header.nativeElement.offsetHeight;
      // Popup cart height
      let popupcart = this.popupcart.nativeElement.offsetHeight;
      document.getElementById("popupcart").style.top = this.headerHeight + 'px';
      document.getElementById("popupcart").style.height = '0px';
      this.popupcartHeight = popupcart;
      // Popup Calendar height
      let popupcalendar = this.popupcalendar.nativeElement.offsetHeight;
      document.getElementById("popupcalendar").style.top = this.headerHeight + 'px';
      document.getElementById("popupcalendar").style.height = '0px';
      this.popupcalendarHeight = popupcalendar;

      // GF height
      let giftcard = this.giftcard.nativeElement.offsetHeight;
      document.getElementById("giftcard").style.top = this.headerHeight + 'px';
      document.getElementById("giftcard").style.height = '0px';
      this.giftcardHeight = giftcard;
    
      if(window.innerWidth <= 640) {
        this.logoImageBoolean = true;
      } else {
        this.logoImageBoolean = false;
      }

      setTimeout(() => {
        document.getElementById("popupcart").style.top = this.headerHeight + 'px';
        document.getElementById("popupcart").style.height = '0px';
        document.getElementById("popupcalendar").style.top = this.headerHeight + 'px';
        document.getElementById("popupcalendar").style.height = '0px';
        document.getElementById("giftcard").style.top = this.headerHeight + 'px';
        document.getElementById("giftcard").style.height = '0px';
        document.getElementById("overlayBlock").style.display = 'none'; 
    }, 0)
    
  }

  @HostListener('window:scroll', ['$event'])
 	onWindowScroll = (e) => {
    if (window.pageYOffset > this.headerHeight) {
       let element = document.getElementById('header');
       element.classList.add('sticky');
     } else {
      let element = document.getElementById('header');
        element.classList.remove('sticky');
     }
  }
  search(){
    this.ClosePopUp();
    this.searchshow = !this.searchshow;  
  }
  toggleMenu(){
    this.ClosePopUp();
    this.menuToggle = !this.menuToggle;  
  }
  changeroute() {
    this.ClosePopUp();
    this.router.navigate(['hotel/'+this.hotel_code]);
  }

  
  
  constructor(private authService: AuthService,public dialog: MatDialog,private router: Router,private route: ActivatedRoute,private commonService: CommonService,calendar: NgbCalendar) {
    this.showLoader = true;
    this.route.firstChild.params.subscribe((params) => {
      this.hotel_code = params.hotelname
    });
    this.commonService.getHotelSettings({'hotel_code':this.hotel_code}).then((data:any) => {
      
      this.hotelData = data.data.data;
      this.hotelDataSubscription = this.commonService.updateHotelData(this.hotelData);
      
      this.hotelID = this.hotelData.hotel_id;
      if(this.hotelData.hotel_id=='121'){
        document.documentElement.style.setProperty("--blue-sh1", "#0298a8"); 
        document.documentElement.style.setProperty("--blk-shd1", "#1D5E65"); 
      } else if(this.hotelData.hotel_id=='120'){
        document.documentElement.style.setProperty("--blue-sh1", "#fe8a00"); 
        document.documentElement.style.setProperty("--blk-shd1", "#8a4400"); 
      } else if(this.hotelData.hotel_id=='122'){
        document.documentElement.style.setProperty("--blue-sh1", "#fe6601"); 
        document.documentElement.style.setProperty("--blk-shd1", "#e27b39"); 
      } else if(this.hotelData.hotel_id=='126'){
        document.documentElement.style.setProperty("--blue-sh1", "#1E5E67"); 
        document.documentElement.style.setProperty("--blk-shd1", "#0a363a"); 
      } else if(this.hotelData.hotel_id=='128'){
        document.documentElement.style.setProperty("--blue-sh1", "#87ba36");
        document.documentElement.style.setProperty("--blk-shd1", "#112363");         
      }else if(this.hotelData.hotel_id=='116'){
        document.documentElement.style.setProperty("--blue-sh1", "#1b67c6");   
        document.documentElement.style.setProperty("--blk-shd1", "#2d323e");         
      }
      this.logoImage = 'assets/img/'+this.hotelData.hotel_id+'.png';
      this.logoImageMobile = 'assets/img/'+this.hotelData.hotel_id+'_logo.png';
      this.hotel_title = this.hotelData.hotel_title;
      console.log(this.hotelData)
      // document.documentElement.style.setProperty("--blk-shd1", "#2d323e"); 
      this.showLoader = false;
    }); 
    this.cartSubscription = this.commonService.totalCartCount.subscribe((cart:any) => {
      this.totalCartItems = cart.cartCount;
      if(this.totalCartItems === undefined || this.totalCartItems ===''){
        this.totalCartItems = 0;
      }
      if(this.showCartDropDown && this.totalCartItems === 0){
        this.ClosePopUp();
      }
    }); 

    this.cartpopup = this.commonService.showCart.subscribe((cart:any) => {
      if(typeof cart !== 'object' && cart !== undefined && cart !== null && cart !==''){
          if(cart){
            this.showCart();
            this.commonService.updateshowCart(false);
          }
      }
    });
    
    
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), 'd', 2);

    this.logInsubscription = this.commonService.userloggedIn.subscribe(res=>{
      this.isLoggedIn = res ? true : false;
    });

    let userAuthentication = localStorage.getItem('AuthToken');
    if(userAuthentication && userAuthentication !== null && userAuthentication !== undefined) {
      this.isLoggedIn = true;
    } else {
      this.loggedInStatus = this.commonService.checkLoginStatus.subscribe((result:any) => {
        if(!result || typeof result ==='object' ) {
          this.isLoggedIn = false;
        } else {
           this.isLoggedIn = true;
        }
      });
    }
    // Show loader  
    this.commonLoaderSub = this.commonService.commonLoader.subscribe((data)=>{
      if(data) {
        this.showCommonLoader = true;
      } else {
        this.showCommonLoader = false;
      } 
    });
  }
  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || date.equals(this.toDate) || this.isInside(date) || this.isHovered(date);
  }


  showCart(){
    this.showCalendarDropDown = false;
    this.showGFDropDown = false;
    if(this.menuToggle){
      this.menuToggle = false
    }
    var mupog = localStorage.getItem('mupog');
    if(document.getElementById("popupcalendar") instanceof HTMLElement){
        document.getElementById("popupcalendar").style.height = '0px';
    }
    if(document.getElementById("giftcard") instanceof HTMLElement){
      document.getElementById("giftcard").style.height = '0px';
    }
    this.showCartDropDown = !this.showCartDropDown;
    if(this.showCartDropDown ){
      if(mupog != undefined && mupog !=''){
        if(document.getElementById("popupcart") instanceof HTMLElement){
          document.getElementById("popupcart").style.height ='max-content';  
        document.getElementById("overlayBlock").style.display = 'block';   
        }
      } else {
          this.showCalender();
      }
    } else {
      document.getElementById("popupcart").style.height = '0px';
      document.getElementById("overlayBlock").style.display = 'none';
    }
  }

     /*************************
  * To close all Dropdown   *
  **************************/
  ClosePopUp(){
    if(this.showCalendarDropDown){
      this.showCalender();
    } else if(this.showCartDropDown){
      this.showCart();
    } else if(this.showGFDropDown){
      this.showGiftCard();
    }
  }

  loadCartData(){
    var mupog = localStorage.getItem('mupog');
    var selectedHotel = JSON.parse(localStorage.getItem('cartHotelData'));
    if(mupog != undefined && mupog !='' && selectedHotel != undefined && selectedHotel != ''){
      this.commonService.loadCartData({'mupog':mupog,'hotelId':selectedHotel.hotel_id}).then((data:any) => {
          if(data.status === 'success'){
              if(data.data.cart_data != undefined && data.data.cart_data != '' && data.data.cart_data.length>0){
                this.cartData = data.data.cart_data;
                this.cartTotal = data.data.cart_total;
                this.totalCartItems = data.data.cart_data[0].cart_items_count;
                localStorage.setItem('cartData',JSON.stringify(this.cartData));
                localStorage.setItem('cartTotal',JSON.stringify(this.cartTotal));
              } else{
                this.cartData = [];
                this.cartTotal = [];
                this.totalCartItems = 0;
                localStorage.removeItem('cartData');
                localStorage.removeItem('mupog');
                localStorage.removeItem('cartTotal');
                localStorage.removeItem('cartHotelData');
                this.showCalender();
              }              
          } else {
              this.showLoader = false;
          }
        });
    }
  }



  showCalender(){
    this.showCartDropDown = false;
    this.showGFDropDown = false;
    if(this.menuToggle){
      this.menuToggle = false
    }
    document.getElementById("popupcart").style.height = '0px';
    document.getElementById("giftcard").style.height = '0px';
    this.showCalendarDropDown = !this.showCalendarDropDown;
    if(this.showCalendarDropDown){
      document.getElementById("popupcalendar").style.height = (this.popupcalendarHeight+60+this.headerHeight) +'px'; 
      // Add day cell height equal to width  
      let dayCell = document.querySelector('.ngb-dp-day');
      if (dayCell instanceof HTMLElement) { 
        let offsetHeight = (dayCell.offsetWidth -2)+'px';
        // let days = document.getElementsByClassName('ngb-dp-day');
        let days = document.querySelectorAll('.date-picker-set-div .ngb-dp-day');
        if(days) { 
          for(let i = 0; i < days.length; i++) {
            days[i].setAttribute('style','height:'+offsetHeight+' !important');
          }
        }
      } 
    } else {
      document.getElementById("popupcalendar").style.height = '0px';
    }
  }

  showGiftCard(){
    this.showCartDropDown = false;
    this.showCalendarDropDown = false;
    if(this.menuToggle){
      this.menuToggle = false;
    }
    document.getElementById("popupcart").style.height = '0px';
    document.getElementById("popupcalendar").style.height = '0px';
    this.showGFDropDown = !this.showGFDropDown;
    if(this.showGFDropDown){
      document.getElementById("giftcard").style.height = (this.giftcardHeight+60+this.headerHeight) +'px';
      document.getElementById("overlayBlock").style.display = 'block';    
    } else {
      document.getElementById("giftcard").style.height = '0px';
      document.getElementById("overlayBlock").style.display = 'none';   
    }
  }
  ngOnInit() {
    this.loadCartData();
  }

  ngOnDestroy() {
    if(this.logInsubscription)
    this.logInsubscription.unsubscribe();
    if(this.loggedInStatus)
    this.loggedInStatus.unsubscribe();
    if(this.commonLoaderSub)
    this.commonLoaderSub.unsubscribe();
  }

  

  // Go to Home Page
  gotoHome(){
    this.ClosePopUp();
    this.router.navigate(['']);
  }

  manageBookings(){
    this.ClosePopUp();
    this.router.navigate(['manage-bookings']);
  }
 
  /******************************/
  /*********** Logout ***********/
  /******************************/
  callLogout() {
    this.isLoggedIn = false;
    this.authService.logout();
    this.commonService.updateCartData(0);
    this.authService.updateLoggedInStatus(false);
    this.commonService.updateLoggedInStatus(false);
    this.commonService.isLoggedIn.next(false);
  }

  /******************************/
  /********* HotelPopup *********/
  /******************************/
  callHotelPopup() {
      localStorage.setItem('manageBookingHotel', JSON.stringify({"hotel":"manhattantowerfl"}));
      this.router.navigate(['/manage-bookings']);
  }

  // Redirect page 
  redirectPage(location) {
    this.router.navigate(['hotel/'+this.hotel_code+'/'+location]);
  }

  redirectPageMobile(location) {
    this.toggleMenu();
    this.router.navigate(['hotel/'+this.hotel_code+'/'+location]);
  }
  goToNewState(state){
    this.ClosePopUp();
    let currentUrl;
    if(state.indexOf('/') == 0) {
      currentUrl = this.router.url.slice(0);
    } else {
      currentUrl = this.router.url.slice(1);
    }
    // if(currentUrl != state) {
    //   this.showCommonLoader =true;
    // }
    
    this.router.navigate([state]);
  }
  
  
}
